import Arrow from './Arrow';
import { trackEvent } from '../lib/analytics';

export default function Cta() {
  return (
    <section className="cta-sec" id="contact">
      <div className="cta-amb" />
      <div className="wrap">
        <div className="cta-band">
          <span className="eyebrow ph" style={{ justifyContent: 'center' }}>
            Start here
          </span>
          <h2 className="editorial" style={{ marginTop: 18 }}>
            See your real number. Book a session.
          </h2>
          <p>
            Bring your stack and your contracts. In one discovery session we will map what
            rcrt consolidates, what it cannot, and the saving you can take to your board —
            priced on what you run, not seats you forgot you bought.
          </p>
          <a
            className="btn btn-primary"
            href="https://calendar.app.google/QJ59uMjvpv5EokCo7"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('cta_click', { cta: 'book_session', location: 'cta_section' })}
          >
            Book a Possibilities Session
            <Arrow />
          </a>
        </div>
      </div>
    </section>
  );
}
